// This file is auto-generated by @hey-api/openapi-ts

export const GET_HEALTH_URL = '/health';

export const LIST_PROJECT_AGENTIC_ARTIFACTS_URL = '/projects/{project_id}/agentic-artifacts';

export const GET_PROJECT_AGENTIC_ARTIFACT_CONTENT_URL = '/projects/{project_id}/agentic-artifacts/content';

export const SEARCH_PROJECT_AGENTIC_ARTIFACTS_URL = '/projects/{project_id}/agentic-artifacts/search';

export const LIST_EDIT_SESSION_AGENTIC_ARTIFACTS_URL = '/edit-sessions/{es_id}/agentic-artifacts';

export const GET_EDIT_SESSION_AGENTIC_ARTIFACT_CONTENT_URL = '/edit-sessions/{es_id}/agentic-artifacts/content';

export const SEARCH_EDIT_SESSION_AGENTIC_ARTIFACTS_URL = '/edit-sessions/{es_id}/agentic-artifacts/search';

export const LIST_THREAD_AGENTIC_ARTIFACTS_URL = '/edit-session-threads/{thread_id}/agentic-artifacts';

export const GET_THREAD_AGENTIC_ARTIFACT_CONTENT_URL = '/edit-session-threads/{thread_id}/agentic-artifacts/content';

export const SEARCH_THREAD_AGENTIC_ARTIFACTS_URL = '/edit-session-threads/{thread_id}/agentic-artifacts/search';

export const GET_AGENTIC_ARTIFACT_CONTENT_BY_TOKEN_URL = '/agentic-artifacts/download';

export const BEGIN_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/projects/{project_id}/agentic-artifacts/workspace-transactions';

export const ABORT_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}';

export const GET_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}';

export const TOUCH_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}/touch';

export const GET_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_CONTENT_URL = '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}/content';

export const LIST_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_ENTRIES_URL = '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}/entries';

export const APPLY_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_PATCH_URL = '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}/patches';

export const PROMOTE_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/projects/{project_id}/agentic-artifacts/workspace-transactions/{transaction_id}/promote';

export const BEGIN_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions';

export const ABORT_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}';

export const GET_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}';

export const TOUCH_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}/touch';

export const GET_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_CONTENT_URL = '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}/content';

export const LIST_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_ENTRIES_URL = '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}/entries';

export const APPLY_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_PATCH_URL = '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}/patches';

export const PROMOTE_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/edit-sessions/{es_id}/agentic-artifacts/workspace-transactions/{transaction_id}/promote';

export const BEGIN_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions';

export const ABORT_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}';

export const GET_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}';

export const TOUCH_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}/touch';

export const GET_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_CONTENT_URL = '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}/content';

export const LIST_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_ENTRIES_URL = '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}/entries';

export const APPLY_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_PATCH_URL = '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}/patches';

export const PROMOTE_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL = '/edit-session-threads/{thread_id}/agentic-artifacts/workspace-transactions/{transaction_id}/promote';

export const LIST_AI_PERSONAS_URL = '/ai-personas';

export const CREATE_AI_PERSONA_URL = '/ai-personas';

export const DELETE_AI_PERSONA_URL = '/ai-personas/{persona_id}';

export const GET_AI_PERSONA_URL = '/ai-personas/{persona_id}';

export const UPDATE_AI_PERSONA_URL = '/ai-personas/{persona_id}';

export const REFRESH_TOKEN_URL = '/auth/refresh';

export const LOGOUT_URL = '/auth/logout';

export const CREATE_CAPABILITY_TOKEN_URL = '/auth/capability-tokens';

export const BROWSER_CREATE_CAPABILITY_TOKEN_URL = '/auth-browser/capability-tokens';

export const BROWSER_LOGOUT_URL = '/auth-browser/logout';

export const GOOGLE_LOGIN_URL = '/auth/google/login';

export const BROWSER_GOOGLE_LOGIN_URL = '/auth-browser/google/login';

export const GENERATE_EXTERNAL_AUTH_CODE_URL = '/auth/external/authcode';

export const BROWSER_GENERATE_EXTERNAL_AUTH_CODE_URL = '/auth-browser/external/authcode';

export const REDEEM_EXTERNAL_AUTH_CODE_URL = '/auth/external/token';

export const DEV_LOGIN_URL = '/auth/dev/login';

export const BROWSER_DEV_LOGIN_URL = '/auth-browser/dev/login';

export const CHECK_AUTHZ_ACTIONS_URL = '/authz/actions/check';

export const GET_BILLING_SUMMARY_URL = '/organizations/{org_id}/billing/summary';

export const LIST_BILLING_PAYMENT_METHODS_URL = '/organizations/{org_id}/billing/payment-methods';

export const CREATE_PAYMENT_METHOD_SETUP_URL = '/organizations/{org_id}/billing/payment-methods/actions/setup';

export const GET_PAYMENT_METHOD_SETUP_ATTEMPT_URL = '/organizations/{org_id}/billing/payment-method-setup-attempts/{attempt_id}';

export const GET_BILLING_PURCHASE_OPTIONS_URL = '/organizations/{org_id}/billing/purchase-options';

export const CREATE_BILLING_PURCHASE_URL = '/organizations/{org_id}/billing/actions/purchase';

export const GET_BILLING_PURCHASE_ATTEMPT_URL = '/organizations/{org_id}/billing/purchase-attempts/{attempt_id}';

export const SET_DEFAULT_PAYMENT_METHOD_URL = '/organizations/{org_id}/billing/payment-methods/{pm_id}/actions/set-default';

export const DELETE_BILLING_PAYMENT_METHOD_URL = '/organizations/{org_id}/billing/payment-methods/{pm_id}';

export const LIST_BILLING_INVOICES_URL = '/organizations/{org_id}/billing/invoices';

export const GET_BILLING_INVOICE_URL = '/organizations/{org_id}/billing/invoices/{invoice_id}';

export const CREATE_CUSTOMER_PORTAL_SESSION_URL = '/organizations/{org_id}/billing/actions/customer-portal-session';

export const SET_UP_BILLING_URL = '/organizations/{org_id}/billing/actions/set-up';

export const GET_USER_BILLING_SUMMARY_URL = '/users/{user_id}/billing/summary';

export const LIST_USER_BILLING_PAYMENT_METHODS_URL = '/users/{user_id}/billing/payment-methods';

export const CREATE_USER_PAYMENT_METHOD_SETUP_URL = '/users/{user_id}/billing/payment-methods/actions/setup';

export const GET_USER_PAYMENT_METHOD_SETUP_ATTEMPT_URL = '/users/{user_id}/billing/payment-method-setup-attempts/{attempt_id}';

export const GET_USER_BILLING_PURCHASE_OPTIONS_URL = '/users/{user_id}/billing/purchase-options';

export const CREATE_USER_BILLING_PURCHASE_URL = '/users/{user_id}/billing/actions/purchase';

export const GET_USER_BILLING_PURCHASE_ATTEMPT_URL = '/users/{user_id}/billing/purchase-attempts/{attempt_id}';

export const SET_USER_DEFAULT_PAYMENT_METHOD_URL = '/users/{user_id}/billing/payment-methods/{pm_id}/actions/set-default';

export const DELETE_USER_BILLING_PAYMENT_METHOD_URL = '/users/{user_id}/billing/payment-methods/{pm_id}';

export const LIST_USER_BILLING_INVOICES_URL = '/users/{user_id}/billing/invoices';

export const GET_USER_BILLING_INVOICE_URL = '/users/{user_id}/billing/invoices/{invoice_id}';

export const SET_UP_USER_BILLING_URL = '/users/{user_id}/billing/actions/set-up';

export const CREATE_USER_CUSTOMER_PORTAL_SESSION_URL = '/users/{user_id}/billing/actions/customer-portal-session';

export const REDIRECT_TO_USER_BILLING_SUMMARY_URL = '/user/billing/summary';

export const REDIRECT_TO_USER_BILLING_PAYMENT_METHODS_URL = '/user/billing/payment-methods';

export const REDIRECT_TO_USER_BILLING_INVOICES_URL = '/user/billing/invoices';

export const REDIRECT_TO_USER_BILLING_INVOICE_URL = '/user/billing/invoices/{invoice_id}';

export const CREATE_BLOB_URL = '/blobs';

export const GET_BLOB_DOWNLOAD_URL_URL = '/blobs/{blob_id}/download-url';

export const COPY_BLOB_URL = '/blobs/{blob_id}/copy';

export const GET_BLOB_CONTENT_URL = '/blobs/{blob_id}/content';

export const CREATE_BLOB_UPLOAD_URL_URL = '/blobs/{blob_id}/upload-url';

export const DELETE_BLOB_URL = '/blobs/{blob_id}';

export const GET_BLOB_LOCAL_GIT_FILE_URL = '/blobs/local-git';

export const UPLOAD_BLOB_LOCAL_GIT_FILE_URL = '/blobs/local-git';

export const GET_BLOB_LOCAL_FILE_URL = '/blobs/local';

export const UPLOAD_BLOB_LOCAL_FILE_URL = '/blobs/local';

export const LIST_PROJECT_BUNDLE_SOURCES_URL = '/projects/{proj_id}/bundle-sources';

export const CREATE_BUNDLE_SOURCE_URL = '/projects/{proj_id}/bundle-sources';

export const DELETE_BUNDLE_SOURCE_URL = '/bundle-sources/{source_id}';

export const GET_BUNDLE_SOURCE_URL = '/bundle-sources/{source_id}';

export const UPDATE_BUNDLE_SOURCE_URL = '/bundle-sources/{source_id}';

export const LIST_SOURCE_BUNDLES_URL = '/bundle-sources/{source_id}/bundles';

export const CREATE_BUNDLE_URL = '/bundle-sources/{source_id}/bundles';

export const DELETE_BUNDLE_URL = '/bundles/{bundle_id}';

export const GET_BUNDLE_URL = '/bundles/{bundle_id}';

export const UPDATE_BUNDLE_URL = '/bundles/{bundle_id}';

export const GET_BUNDLE_CONTENT_REDIRECT_URL = '/bundles/{bundle_id}/content';

export const GENERATE_BUNDLE_CONTENT_UPLOAD_URL_URL = '/bundles/{bundle_id}/content';

export const LIST_BUNDLE_DEPLOYMENTS_URL = '/bundles/{bundle_id}/deployments';

export const DIFF_BUNDLES_URL = '/bundles/{bundle_id}/actions/diff';

export const DEPLOY_BUNDLE_URL = '/bundles/{bundle_id}/actions/deploy';

export const LIST_PROJECT_BUNDLE_ENVIRONMENTS_URL = '/projects/{proj_id}/bundle-environments';

export const CREATE_BUNDLE_ENVIRONMENT_URL = '/projects/{proj_id}/bundle-environments';

export const DELETE_BUNDLE_ENVIRONMENT_URL = '/bundle-environments/{env_id}';

export const GET_BUNDLE_ENVIRONMENT_URL = '/bundle-environments/{env_id}';

export const UPDATE_BUNDLE_ENVIRONMENT_URL = '/bundle-environments/{env_id}';

export const REDIRECT_TO_CURRENT_BUNDLE_URL = '/bundle-environments/{env_id}/bundle';

export const REDIRECT_TO_CURRENT_BUNDLE_CONTENT_URL = '/bundle-environments/{env_id}/bundle/content';

export const LIST_BUNDLE_ENVIRONMENT_DEPLOYMENTS_URL = '/bundle-environments/{env_id}/deployments';

export const DELETE_BUNDLE_DEPLOYMENT_URL = '/bundle-deployments/{deployment_id}';

export const GET_BUNDLE_DEPLOYMENT_URL = '/bundle-deployments/{deployment_id}';

export const UPDATE_BUNDLE_DEPLOYMENT_URL = '/bundle-deployments/{deployment_id}';

export const REDIRECT_TO_USER_CHATS_URL = '/user/chats';

export const LIST_USER_CHATS_URL = '/users/{user_id}/chats';

export const CREATE_USER_CHAT_URL = '/users/{user_id}/chats';

export const DELETE_CHAT_URL = '/chats/{chat_id}';

export const GET_CHAT_URL = '/chats/{chat_id}';

export const UPDATE_CHAT_URL = '/chats/{chat_id}';

export const LIST_CHAT_BRANCHES_URL = '/chats/{chat_id}/branches';

export const SWITCH_CHAT_BRANCH_URL = '/chats/{chat_id}/actions/switch-branch';

export const REDIRECT_TO_CHAT_MESSAGES_URL = '/chats/{chat_id}/messages';

export const DELETE_CHAT_BRANCH_URL = '/chat-branches/{branch_id}';

export const GET_CHAT_BRANCH_URL = '/chat-branches/{branch_id}';

export const LIST_LLM_MODEL_OPTIONS_URL = '/llm-model-options';

export const GET_CHAT_BRANCH_LLM_VIEW_URL = '/chat-branches/{branch_id}/llm-view';

export const LIST_EDIT_SESSION_FS_ENTRIES_URL = '/edit-sessions/{es_id}/content/fs';

export const CREATE_FS_ENTRY_URL = '/edit-sessions/{es_id}/content/fs';

export const DELETE_FS_ENTRY_URL = '/edit-sessions/{es_id}/content/fs/{id}';

export const GET_EDIT_SESSION_FS_ENTRY_URL = '/edit-sessions/{es_id}/content/fs/{id}';

export const UPDATE_FS_ENTRY_URL = '/edit-sessions/{es_id}/content/fs/{id}';

export const GET_EDIT_SESSION_FS_ENTRY_CONTENT_URL = '/edit-sessions/{es_id}/content/fs/{id}/content';

export const PATCH_FS_ENTRY_CONTENT_URL = '/edit-sessions/{es_id}/content/fs/{id}/content';

export const REQUEST_UPLOAD_URL_URL = '/edit-sessions/{es_id}/content/fs/{id}/content';

export const REPLACE_FS_ENTRY_CONTENT_URL = '/edit-sessions/{es_id}/content/fs/{id}/content';

export const GET_EDIT_SESSION_FS_ENTRY_BY_PATH_URL = '/edit-sessions/{es_id}/content/fs-by-path/{path}';

export const GET_EDIT_SESSION_FS_ENTRY_CONTENT_BY_PATH_URL = '/edit-sessions/{es_id}/content/fs-by-path/{path}/content';

export const COPY_FS_ENTRY_URL = '/edit-sessions/{es_id}/content/fs/{id}/actions/copy';

export const REIMPORT_FS_ENTRY_URL = '/edit-sessions/{es_id}/content/fs/{id}/actions/reimport';

export const VALIDATE_EDIT_SESSION_FS_ENTRY_URL = '/edit-sessions/{es_id}/content/fs/{id}/actions/validate';

export const CREATE_FS_ENTRY_FROM_DATA_URL = '/edit-sessions/{es_id}/content/fs/{folder_id}/actions/create-from-data';

export const LIST_EDIT_SESSION_PROBLEMS_URL = '/edit-sessions/{es_id}/problems';

export const REIMPORT_EDIT_SESSION_CONTENT_PATH_URL = '/edit-sessions/{es_id}/content/actions/reimport';

export const TRIGGER_EDIT_SESSION_VALIDATION_URL = '/edit-sessions/{es_id}/content/actions/validate';

export const REFRESH_EDIT_SESSION_CONTENT_TREE_URL = '/edit-sessions/{es_id}/content/tree/actions/refresh';

export const GET_EDIT_SESSION_CONTENT_TREE_URL = '/edit-sessions/{es_id}/content/tree';

export const LIST_CONTEXT_SUGGESTIONS_URL = '/projects/{proj_id}/edit-sessions/context-suggestions';

export const LIST_EDIT_SESSIONS_URL = '/projects/{proj_id}/edit-sessions';

export const CREATE_EDIT_SESSION_URL = '/projects/{proj_id}/edit-sessions';

export const DELETE_EDIT_SESSION_URL = '/edit-sessions/{es_id}';

export const GET_EDIT_SESSION_URL = '/edit-sessions/{es_id}';

export const UPDATE_EDIT_SESSION_URL = '/edit-sessions/{es_id}';

export const ARCHIVE_EDIT_SESSION_URL = '/edit-sessions/{es_id}/content/actions/archive';

export const UNDO_EDIT_SESSION_URL = '/edit-sessions/{es_id}/content/actions/undo';

export const REDO_EDIT_SESSION_URL = '/edit-sessions/{es_id}/content/actions/redo';

export const REVERT_EDIT_SESSION_URL = '/edit-sessions/{es_id}/content/actions/revert';

export const LIST_EDIT_SESSION_HISTORY_URL = '/edit-sessions/{es_id}/content/history';

export const GET_EDIT_SESSION_HISTORY_ITEM_URL = '/edit-sessions/{es_id}/content/history/{item_id}';

export const GET_EDIT_SESSION_HISTORY_ITEM_DIFF_URL = '/edit-sessions/{es_id}/content/history/{item_id}/diff';

export const GET_EDIT_SESSION_HISTORY_ITEM_SUMMARY_URL = '/edit-sessions/{es_id}/content/history/{item_id}/summary';

export const CAN_MERGE_EDIT_SESSION_URL = '/edit-sessions/{es_id}/content/actions/can-merge';

export const MERGE_EDIT_SESSION_URL = '/edit-sessions/{es_id}/content/actions/merge';

export const CAN_SYNC_EDIT_SESSION_URL = '/edit-sessions/{es_id}/content/actions/can-sync';

export const SYNC_EDIT_SESSION_URL = '/edit-sessions/{es_id}/content/actions/sync';

export const GET_EDIT_SESSION_DIFF_URL = '/edit-sessions/{es_id}/content/diff';

export const LIST_EDIT_SESSION_THREADS_URL = '/edit-sessions/{es_id}/threads';

export const CREATE_EDIT_SESSION_THREAD_URL = '/edit-sessions/{es_id}/threads';

export const LIST_EDIT_SESSION_CHATS_URL = '/edit-sessions/{es_id}/chats';

export const CREATE_EDIT_SESSION_CHAT_URL = '/edit-sessions/{es_id}/chats';

export const LIST_THREAD_FS_ENTRIES_URL = '/edit-session-threads/{thread_id}/content/fs';

export const CREATE_THREAD_FS_ENTRY_URL = '/edit-session-threads/{thread_id}/content/fs';

export const DELETE_THREAD_FS_ENTRY_URL = '/edit-session-threads/{thread_id}/content/fs/{id}';

export const GET_THREAD_FS_ENTRY_URL = '/edit-session-threads/{thread_id}/content/fs/{id}';

export const UPDATE_THREAD_FS_ENTRY_URL = '/edit-session-threads/{thread_id}/content/fs/{id}';

export const GET_THREAD_FS_ENTRY_CONTENT_URL = '/edit-session-threads/{thread_id}/content/fs/{id}/content';

export const PATCH_THREAD_FS_ENTRY_CONTENT_URL = '/edit-session-threads/{thread_id}/content/fs/{id}/content';

export const REQUEST_THREAD_UPLOAD_URL_URL = '/edit-session-threads/{thread_id}/content/fs/{id}/content';

export const REPLACE_THREAD_FS_ENTRY_CONTENT_URL = '/edit-session-threads/{thread_id}/content/fs/{id}/content';

export const GET_THREAD_FS_ENTRY_BY_PATH_URL = '/edit-session-threads/{thread_id}/content/fs-by-path/{path}';

export const GET_THREAD_FS_ENTRY_CONTENT_BY_PATH_URL = '/edit-session-threads/{thread_id}/content/fs-by-path/{path}/content';

export const COPY_THREAD_FS_ENTRY_URL = '/edit-session-threads/{thread_id}/content/fs/{id}/actions/copy';

export const REIMPORT_THREAD_FS_ENTRY_URL = '/edit-session-threads/{thread_id}/content/fs/{id}/actions/reimport';

export const VALIDATE_THREAD_FS_ENTRY_URL = '/edit-session-threads/{thread_id}/content/fs/{id}/actions/validate';

export const CREATE_THREAD_FS_ENTRY_FROM_DATA_URL = '/edit-session-threads/{thread_id}/content/fs/{folder_id}/actions/create-from-data';

export const LIST_THREAD_PROBLEMS_URL = '/edit-session-threads/{thread_id}/problems';

export const REIMPORT_THREAD_CONTENT_PATH_URL = '/edit-session-threads/{thread_id}/content/actions/reimport';

export const TRIGGER_THREAD_VALIDATION_URL = '/edit-session-threads/{thread_id}/content/actions/validate';

export const REFRESH_THREAD_CONTENT_TREE_URL = '/edit-session-threads/{thread_id}/content/tree/actions/refresh';

export const GET_THREAD_CONTENT_TREE_URL = '/edit-session-threads/{thread_id}/content/tree';

export const DELETE_THREAD_URL = '/edit-session-threads/{thread_id}';

export const GET_THREAD_URL = '/edit-session-threads/{thread_id}';

export const UPDATE_THREAD_URL = '/edit-session-threads/{thread_id}';

export const ARCHIVE_THREAD_URL = '/edit-session-threads/{thread_id}/actions/archive';

export const UNARCHIVE_THREAD_URL = '/edit-session-threads/{thread_id}/actions/unarchive';

export const CAN_MERGE_THREAD_URL = '/edit-session-threads/{thread_id}/content/actions/can-merge';

export const MERGE_THREAD_URL = '/edit-session-threads/{thread_id}/content/actions/merge';

export const CAN_SYNC_THREAD_URL = '/edit-session-threads/{thread_id}/content/actions/can-sync';

export const SYNC_THREAD_URL = '/edit-session-threads/{thread_id}/content/actions/sync';

export const CANCEL_MERGE_RESOLUTION_THREAD_URL = '/edit-session-threads/{thread_id}/content/actions/cancel-merge-resolution';

export const GET_THREAD_DIFF_URL = '/edit-session-threads/{thread_id}/content/diff';

export const LIST_THREAD_HISTORY_URL = '/edit-session-threads/{thread_id}/content/history';

export const GET_THREAD_HISTORY_ITEM_URL = '/edit-session-threads/{thread_id}/content/history/{item_id}';

export const GET_THREAD_HISTORY_ITEM_DIFF_URL = '/edit-session-threads/{thread_id}/content/history/{item_id}/diff';

export const GET_THREAD_HISTORY_ITEM_SUMMARY_URL = '/edit-session-threads/{thread_id}/content/history/{item_id}/summary';

export const REVERT_THREAD_URL = '/edit-session-threads/{thread_id}/content/actions/revert';

export const LIST_PROJECT_EXTERNAL_RUNS_URL = '/projects/{project_id}/external-runs';

export const CREATE_PROJECT_EXTERNAL_RUN_URL = '/projects/{project_id}/external-runs';

export const DELETE_PROJECT_EXTERNAL_RUN_URL = '/projects/{project_id}/external-runs/{run_id}';

export const GET_PROJECT_EXTERNAL_RUN_URL = '/projects/{project_id}/external-runs/{run_id}';

export const UPDATE_PROJECT_EXTERNAL_RUN_SETTINGS_URL = '/projects/{project_id}/external-runs/{run_id}/settings';

export const CREATE_PROJECT_EXTERNAL_RUN_WORKSPACE_TRANSACTION_URL = '/projects/{project_id}/external-runs/{run_id}/workspace-transactions';

export const START_PROJECT_EXTERNAL_RUN_URL = '/projects/{project_id}/external-runs/{run_id}/start';

export const COMPLETE_PROJECT_EXTERNAL_RUN_URL = '/projects/{project_id}/external-runs/{run_id}/complete';

export const CANCEL_PROJECT_EXTERNAL_RUN_URL = '/projects/{project_id}/external-runs/{run_id}/cancel';

export const APPEND_PROJECT_EXTERNAL_RUN_RECORD_URL = '/projects/{project_id}/external-runs/{run_id}/records/{record_kind}';

export const LIST_PROJECT_EXTERNAL_RUN_RECORDS_URL = '/projects/{project_id}/external-runs/{run_id}/records';

export const GET_PROJECT_EXTERNAL_RUN_RECORD_CONTENT_URL = '/projects/{project_id}/external-runs/{run_id}/records/{record_id}/content';

export const LIST_EDIT_SESSION_EXTERNAL_RUNS_URL = '/edit-sessions/{es_id}/external-runs';

export const CREATE_EDIT_SESSION_EXTERNAL_RUN_URL = '/edit-sessions/{es_id}/external-runs';

export const DELETE_EDIT_SESSION_EXTERNAL_RUN_URL = '/edit-sessions/{es_id}/external-runs/{run_id}';

export const GET_EDIT_SESSION_EXTERNAL_RUN_URL = '/edit-sessions/{es_id}/external-runs/{run_id}';

export const UPDATE_EDIT_SESSION_EXTERNAL_RUN_SETTINGS_URL = '/edit-sessions/{es_id}/external-runs/{run_id}/settings';

export const CREATE_EDIT_SESSION_EXTERNAL_RUN_WORKSPACE_TRANSACTION_URL = '/edit-sessions/{es_id}/external-runs/{run_id}/workspace-transactions';

export const START_EDIT_SESSION_EXTERNAL_RUN_URL = '/edit-sessions/{es_id}/external-runs/{run_id}/start';

export const COMPLETE_EDIT_SESSION_EXTERNAL_RUN_URL = '/edit-sessions/{es_id}/external-runs/{run_id}/complete';

export const CANCEL_EDIT_SESSION_EXTERNAL_RUN_URL = '/edit-sessions/{es_id}/external-runs/{run_id}/cancel';

export const APPEND_EDIT_SESSION_EXTERNAL_RUN_RECORD_URL = '/edit-sessions/{es_id}/external-runs/{run_id}/records/{record_kind}';

export const LIST_EDIT_SESSION_EXTERNAL_RUN_RECORDS_URL = '/edit-sessions/{es_id}/external-runs/{run_id}/records';

export const GET_EDIT_SESSION_EXTERNAL_RUN_RECORD_CONTENT_URL = '/edit-sessions/{es_id}/external-runs/{run_id}/records/{record_id}/content';

export const LIST_THREAD_EXTERNAL_RUNS_URL = '/edit-session-threads/{thread_id}/external-runs';

export const CREATE_THREAD_EXTERNAL_RUN_URL = '/edit-session-threads/{thread_id}/external-runs';

export const DELETE_THREAD_EXTERNAL_RUN_URL = '/edit-session-threads/{thread_id}/external-runs/{run_id}';

export const GET_THREAD_EXTERNAL_RUN_URL = '/edit-session-threads/{thread_id}/external-runs/{run_id}';

export const UPDATE_THREAD_EXTERNAL_RUN_SETTINGS_URL = '/edit-session-threads/{thread_id}/external-runs/{run_id}/settings';

export const CREATE_THREAD_EXTERNAL_RUN_WORKSPACE_TRANSACTION_URL = '/edit-session-threads/{thread_id}/external-runs/{run_id}/workspace-transactions';

export const START_THREAD_EXTERNAL_RUN_URL = '/edit-session-threads/{thread_id}/external-runs/{run_id}/start';

export const COMPLETE_THREAD_EXTERNAL_RUN_URL = '/edit-session-threads/{thread_id}/external-runs/{run_id}/complete';

export const CANCEL_THREAD_EXTERNAL_RUN_URL = '/edit-session-threads/{thread_id}/external-runs/{run_id}/cancel';

export const APPEND_THREAD_EXTERNAL_RUN_RECORD_URL = '/edit-session-threads/{thread_id}/external-runs/{run_id}/records/{record_kind}';

export const LIST_THREAD_EXTERNAL_RUN_RECORDS_URL = '/edit-session-threads/{thread_id}/external-runs/{run_id}/records';

export const GET_THREAD_EXTERNAL_RUN_RECORD_CONTENT_URL = '/edit-session-threads/{thread_id}/external-runs/{run_id}/records/{record_id}/content';

export const DELETE_INVITATION_URL = '/invitations/{invitation_id}';

export const GET_INVITATION_BY_TOKEN_URL = '/invitations/token/{token}';

export const GET_INVITATION_RESOURCE_BY_TOKEN_URL = '/invitations/token/{token}/resource';

export const ACCEPT_INVITATION_URL = '/invitations/actions/accept';

export const DECLINE_INVITATION_URL = '/invitations/actions/decline';

export const GET_PROJECT_INVITE_LINK_PREVIEW_URL = '/project-invite-links/token/{token}/preview';

export const ACCEPT_PROJECT_INVITE_LINK_URL = '/project-invite-links/actions/accept';

export const LIST_USER_INVITATIONS_REDIRECT_URL = '/user/invitations';

export const LIST_USER_INVITATIONS_URL = '/users/{user_id}/invitations';

export const LIST_PROJECT_INVITATIONS_URL = '/projects/{proj_id}/invitations';

export const SEND_PROJECT_INVITATION_URL = '/projects/{proj_id}/invitations';

export const LIST_PROJECT_INVITE_LINKS_URL = '/projects/{proj_id}/invite-links';

export const CREATE_PROJECT_INVITE_LINK_URL = '/projects/{proj_id}/invite-links';

export const REVOKE_PROJECT_INVITE_LINK_URL = '/projects/{proj_id}/invite-links/{invitation_id}';

export const LIST_ORGANIZATION_INVITATIONS_URL = '/organizations/{org_id}/invitations';

export const SEND_ORGANIZATION_INVITATION_URL = '/organizations/{org_id}/invitations';

export const SEED_LOCAL_DEV_ENTERPRISE_URL = '/local-dev/enterprise/actions/seed';

export const LIST_PROJECT_MARKETING_URL = '/projects/{project_id}/marketing';

export const CREATE_PROJECT_MARKETING_URL = '/projects/{project_id}/marketing';

export const DELETE_PROJECT_MARKETING_URL = '/projects/{project_id}/marketing/{marketing_id}';

export const RENAME_PROJECT_MARKETING_URL = '/projects/{project_id}/marketing/{marketing_id}';

export const LIST_USER_MEMBERSHIPS_URL = '/users/{user_id}/memberships';

export const LIST_ORGANIZATION_MEMBERS_URL = '/organizations/{org_id}/members';

export const REMOVE_ORGANIZATION_MEMBER_URL = '/organizations/{org_id}/members/{user_id}';

export const UPDATE_ORGANIZATION_MEMBER_URL = '/organizations/{org_id}/members/{user_id}';

export const LIST_PROJECT_MEMBERS_URL = '/projects/{proj_id}/members';

export const REMOVE_PROJECT_MEMBER_URL = '/projects/{proj_id}/members/{user_id}';

export const UPDATE_PROJECT_MEMBER_URL = '/projects/{proj_id}/members/{user_id}';

export const LIST_ORGANIZATIONS_URL = '/organizations';

export const CREATE_ORGANIZATION_URL = '/organizations';

export const GET_ORGANIZATION_URL = '/organizations/{org_id}';

export const UPDATE_ORGANIZATION_URL = '/organizations/{org_id}';

export const ARCHIVE_ORGANIZATION_URL = '/organizations/{org_id}/actions/archive';

export const TRANSFER_OWNERSHIP_URL = '/organizations/{org_id}/actions/transfer-ownership';

export const REDIRECT_TO_USER_ORGANIZATIONS_URL = '/user/organizations';

export const REDIRECT_TO_USER_ORGANIZATION_MEMBERSHIPS_URL = '/users/{user_id}/organizations';

export const LIST_PROJECT_SKILLS_URL = '/projects/{proj_id}/skills';

export const RUN_PROJECT_SKILL_SCRIPT_URL = '/projects/{proj_id}/skills/{skill_name}/actions/run-script';

export const RUN_PROJECT_SKILL_BINARY_URL = '/projects/{proj_id}/skills/{skill_name}/actions/run-binary';

export const RUN_PROJECT_PLUGIN_SCRIPT_URL = '/projects/{proj_id}/plugins/{plugin_id}/actions/run-script';

export const RUN_PROJECT_PLUGIN_BINARY_URL = '/projects/{proj_id}/plugins/{plugin_id}/actions/run-binary';

export const LIST_EDIT_SESSION_SKILLS_URL = '/edit-sessions/{es_id}/skills';

export const RUN_EDIT_SESSION_SKILL_SCRIPT_URL = '/edit-sessions/{es_id}/skills/{skill_name}/actions/run-script';

export const RUN_EDIT_SESSION_SKILL_BINARY_URL = '/edit-sessions/{es_id}/skills/{skill_name}/actions/run-binary';

export const RUN_EDIT_SESSION_PLUGIN_SCRIPT_URL = '/edit-sessions/{es_id}/plugins/{plugin_id}/actions/run-script';

export const RUN_EDIT_SESSION_PLUGIN_BINARY_URL = '/edit-sessions/{es_id}/plugins/{plugin_id}/actions/run-binary';

export const LIST_EDIT_SESSION_THREAD_SKILLS_URL = '/edit-session-threads/{thread_id}/skills';

export const RUN_EDIT_SESSION_THREAD_SKILL_SCRIPT_URL = '/edit-session-threads/{thread_id}/skills/{skill_name}/actions/run-script';

export const RUN_EDIT_SESSION_THREAD_SKILL_BINARY_URL = '/edit-session-threads/{thread_id}/skills/{skill_name}/actions/run-binary';

export const RUN_EDIT_SESSION_THREAD_PLUGIN_SCRIPT_URL = '/edit-session-threads/{thread_id}/plugins/{plugin_id}/actions/run-script';

export const RUN_EDIT_SESSION_THREAD_PLUGIN_BINARY_URL = '/edit-session-threads/{thread_id}/plugins/{plugin_id}/actions/run-binary';

export const REDIRECT_TO_USER_PRESENCE_RECORD_URL = '/user/presence';

export const RECORD_USER_PRESENCE_URL = '/users/{user_id}/presence';

export const REDIRECT_TO_USER_PROJECTS_URL = '/user/projects';

export const REDIRECT_TO_USER_PROJECT_MEMBERSHIPS_URL = '/users/{user_id}/projects';

export const GET_PROJECT_URL = '/projects/{proj_id}';

export const UPDATE_PROJECT_URL = '/projects/{proj_id}';

export const UPLOAD_PROJECT_THUMBNAIL_URL = '/projects/{proj_id}/thumbnail';

export const ARCHIVE_PROJECT_URL = '/projects/{proj_id}/actions/archive';

export const DUPLICATE_PROJECT_URL = '/projects/{proj_id}/actions/duplicate';

export const GET_PROJECT_COPY_OPERATION_URL = '/project-copy-operations/{operation_id}';

export const LIST_ORGANIZATION_PROJECTS_URL = '/organizations/{org_id}/projects';

export const CREATE_ORGANIZATION_PROJECT_URL = '/organizations/{org_id}/projects';

export const LIST_FS_ENTRIES_URL = '/projects/{proj_id}/content/fs';

export const GET_FS_ENTRY_URL = '/fs/{id}';

export const GET_FS_ENTRY_CONTENT_URL = '/fs/{id}/content';

export const GET_FS_ENTRY_BY_PATH_URL = '/projects/{proj_id}/content/fs-by-path/{path}';

export const GET_FS_ENTRY_CONTENT_BY_PATH_URL = '/projects/{proj_id}/content/fs-by-path/{path}/content';

export const LIST_PROBLEMS_URL = '/projects/{proj_id}/problems';

export const REFRESH_CONTENT_TREE_URL = '/projects/{proj_id}/content/tree/actions/refresh';

export const REIMPORT_CONTENT_PATH_URL = '/projects/{proj_id}/content/actions/reimport';

export const GET_CONTENT_TREE_URL = '/projects/{proj_id}/content/tree';

export const GET_STRUCTURED_TYPE_INFO_IN_PROJECT_URL = '/projects/{proj_id}/structured-types/{type_id}';

export const GET_STRUCTURED_TYPE_SCHEMA_IN_PROJECT_URL = '/projects/{proj_id}/structured-types/{type_id}/schema';

export const GET_STRUCTURED_VALUE_INFO_IN_PROJECT_URL = '/projects/{proj_id}/structured-values/{id}';

export const REDIRECT_STRUCTURED_VALUE_TYPE_IN_PROJECT_URL = '/projects/{proj_id}/structured-values/{id}/type';

export const REDIRECT_STRUCTURED_VALUE_TYPE_SCHEMA_IN_PROJECT_URL = '/projects/{proj_id}/structured-values/{id}/type/schema';

export const BUILD_STRUCTURED_VALUE_IN_PROJECT_URL = '/projects/{proj_id}/structured-values/{id}/actions/build';

export const GET_STRUCTURED_TYPE_INFO_IN_EDIT_SESSION_URL = '/edit-sessions/{es_id}/structured-types/{type_id}';

export const GET_STRUCTURED_TYPE_SCHEMA_IN_EDIT_SESSION_URL = '/edit-sessions/{es_id}/structured-types/{type_id}/schema';

export const GET_STRUCTURED_VALUE_INFO_IN_EDIT_SESSION_URL = '/edit-sessions/{es_id}/structured-values/{id}';

export const REDIRECT_STRUCTURED_VALUE_TYPE_IN_EDIT_SESSION_URL = '/edit-sessions/{es_id}/structured-values/{id}/type';

export const REDIRECT_STRUCTURED_VALUE_TYPE_SCHEMA_IN_EDIT_SESSION_URL = '/edit-sessions/{es_id}/structured-values/{id}/type/schema';

export const BUILD_STRUCTURED_VALUE_IN_EDIT_SESSION_URL = '/edit-sessions/{es_id}/structured-values/{id}/actions/build';

export const GET_STRUCTURED_TYPE_INFO_IN_EDIT_THREAD_URL = '/edit-threads/{thread_id}/structured-types/{type_id}';

export const GET_STRUCTURED_TYPE_SCHEMA_IN_EDIT_THREAD_URL = '/edit-threads/{thread_id}/structured-types/{type_id}/schema';

export const GET_STRUCTURED_VALUE_INFO_IN_EDIT_THREAD_URL = '/edit-threads/{thread_id}/structured-values/{id}';

export const REDIRECT_STRUCTURED_VALUE_TYPE_IN_EDIT_THREAD_URL = '/edit-threads/{thread_id}/structured-values/{id}/type';

export const REDIRECT_STRUCTURED_VALUE_TYPE_SCHEMA_IN_EDIT_THREAD_URL = '/edit-threads/{thread_id}/structured-values/{id}/type/schema';

export const BUILD_STRUCTURED_VALUE_IN_EDIT_THREAD_URL = '/edit-threads/{thread_id}/structured-values/{id}/actions/build';

export const GET_STRUCTURED_VALUE_EDITOR_SCHEMA_IN_EDIT_SESSION_URL = '/edit-sessions/{es_id}/structured-values/{id}/actions/schema-for-editor';

export const GET_STRUCTURED_VALUE_EDITOR_SCHEMA_IN_EDIT_THREAD_URL = '/edit-threads/{thread_id}/structured-values/{id}/actions/schema-for-editor';

export const LIST_PROJECT_TEMPLATES_URL = '/project-templates';

export const SEED_ORG_PROJECTS_URL = '/organizations/{org_id}/actions/seed-projects';

export const GET_PROJECT_TEMPLATE_URL = '/project-templates/{template_id}';

export const GET_SERVICE_ACCOUNT_REDIRECT_URL = '/service-account';

export const GET_SERVICE_ACCOUNT_BY_ID_URL = '/service-accounts/{service_account_id}';

export const REPORT_USAGE_RECORDS_URL = '/usage/records';

export const GET_ORG_USAGE_SUMMARY_URL = '/organizations/{org_id}/usage/summary';

export const LIST_ORG_USAGE_HISTORY_URL = '/organizations/{org_id}/usage/history';

export const GET_PROJECT_USAGE_SUMMARY_URL = '/projects/{proj_id}/usage/summary';

export const LIST_PROJECT_USAGE_HISTORY_URL = '/projects/{proj_id}/usage/history';

export const GET_CHAT_BRANCH_USAGE_SUMMARY_URL = '/chat-branches/{branch_id}/usage/summary';

export const GET_USER_USAGE_SUMMARY_URL = '/users/{user_id}/usage/summary';

export const LIST_USER_USAGE_HISTORY_URL = '/users/{user_id}/usage/history';

export const REDIRECT_TO_USER_USAGE_SUMMARY_URL = '/user/usage/summary';

export const REDIRECT_TO_USER_USAGE_HISTORY_URL = '/user/usage/history';

export const DELETE_USER_URL = '/user';

export const GET_USER_REDIRECT_URL = '/user';

export const UPDATE_USER_URL = '/user';

export const DELETE_USER_AVATAR_REDIRECT_URL = '/user/avatar';

export const GET_USER_AVATAR_REDIRECT_URL = '/user/avatar';

export const UPLOAD_USER_AVATAR_REDIRECT_URL = '/user/avatar';

export const DELETE_USER_BY_ID_URL = '/users/{user_id}';

export const GET_USER_URL = '/users/{user_id}';

export const UPDATE_USER_BY_ID_URL = '/users/{user_id}';

export const DELETE_USER_AVATAR_URL = '/users/{user_id}/avatar';

export const GET_USER_AVATAR_URL = '/users/{user_id}/avatar';

export const UPLOAD_USER_AVATAR_URL = '/users/{user_id}/avatar';

export const LIST_USER_MEMBERSHIPS_REDIRECT_URL = '/user/memberships';

export const STOP_AI_PERSONA_ANSWER_URL = '/ai-personas/{persona_id}/actions/stop-answer';

export const REDIRECT_TO_CREATE_CHAT_MESSAGE_URL = '/chats/{chat_id}/messages';

export const UPDATE_CHAT_BRANCH_MESSAGE_URL = '/chat-branches/{branch_id}/messages/{message_id}';

export const LIST_CHAT_BRANCH_MESSAGES_URL = '/chat-branches/{branch_id}/messages';

export const CREATE_CHAT_BRANCH_MESSAGE_URL = '/chat-branches/{branch_id}/messages';

export const INTERACT_WITH_CHAT_MESSAGE_URL = '/chat-branches/{branch_id}/messages/{message_id}/actions/interact';

export const ANSWER_CHAT_QUESTIONS_URL = '/chat-branches/{branch_id}/messages/{message_id}/actions/answer-questions';

export const STREAM_EVENTS_URL = '/events';
